// Styles
import "./hero-slideshow.scss";

if (!window.dAgency) window.dAgency = {};
window.dAgency.initHeroSlideshow = (context) => {
  const heroSlideshowSection = context.closest(".shopify-section");

  if (!heroSlideshowSection) return;

  const slidesContainer = heroSlideshowSection.querySelector(
    ".hero-slideshow__container"
  );

  const slides = slidesContainer.querySelectorAll(
    ".swiper-wrapper .hero-slideshow__slide"
  );
  const slidesLabels = slidesContainer.querySelectorAll(
    ".hero-slideshow__pagination .hero-slideshow__slide__text__title"
  );

  const slidesPagination = slidesContainer.querySelector(
    ".hero-slideshow__pagination"
  );

  const slidesCount = slides.length;

  slides.forEach((slide) => {
    slide.addEventListener("click", (e) => {
      if (e.target.dataset.slideRedirect) {
        location.href = e.target.dataset.slideRedirect;
      }
    });
  });

  if (slidesCount > 0) {
    new Swiper(slidesContainer, {
      autoHeight: true,
      autoplay: {
        enabled: JSON.parse(slidesContainer.dataset.swiperAutoplay) && slidesCount > 1,
        disableOnInteraction: false,
      },
      loop: slidesCount > 1,
      pagination: {
        el: slidesContainer.querySelector(".hero-slideshow__pagination"),
        clickable: true,
        renderBullet: (index, className) => {
          return (
            '<span class="' +
            className +
            '">' +
            slidesLabels[index].innerHTML +
            "</span>"
          );
        },
      },
      on: {
        init: function (swiper) {
          let currentSlide = $(slidesContainer).find('.swiper-slide-active');
          if ($(currentSlide).hasClass('swiper-slide-active')) {
            if ($(currentSlide).hasClass('has_text')) {
              $(slidesPagination).show();
            } else {
              $(slidesPagination).hide();
            }
          }
        },
        slideChangeTransitionStart: function (swiper) {
          let currentSlide = $(slidesContainer).find('.swiper-slide-active');
          if ($(currentSlide).hasClass('swiper-slide-active')) {
            if ($(currentSlide).hasClass('has_text')) {
              $(slidesPagination).show();
            } else {
              $(slidesPagination).hide();
            }
          }
        }
      }
    });
  }
};

if (document.readyState != "loading") {
  [].forEach.call(
    document.querySelectorAll(".hero-slideshow__container"),
    (el) => {
      window.dAgency.initHeroSlideshow(el);
    }
  );
} else {
  document.addEventListener("DOMContentLoaded", () => {
    [].forEach.call(
      document.querySelectorAll(".hero-slideshow__container"),
      (el) => {
        window.dAgency.initHeroSlideshow(el);
      }
    );
  });
}
